import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const Wraper = styled.div`
  width: 100%;

  & .slick-slide {
    height: auto;
  }
  & .slick-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;

    & .slick-slide > div {
      height: 100%;
    }
  }
`;

export const ContainerItem = styled.div`
  position: relative;
  height: 100%;

  @media ${device.desktop} {
    padding-inline: 10px;
  }
`;

export const ThumbImage = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
`;

export const TotalBox = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 9px 15px;
  background: rgba(var(--bg-button-rgb), 0.45);
  backdrop-filter: blur(3.5px);
  border-radius: 0px 10px 0px 0px;
`;

export const TotalText = styled.p`
  color: var(--button-text-color);
  font-weight: 500;
  font-size: 8px;
  line-height: 1.25;
`;

export const TotalSum = styled.p`
  color: var(--button-text-color);
  font-weight: 700;
  font-size: 15px;
  line-height: 1.22;
`;

export const Title = styled.h1`
  margin-bottom: 10px;
  text-align: inherit;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.23;
  color: var(--title-text-color);
`;

export const Text = styled.p`
  margin-bottom: 80px;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.27;
  color: var(--text-color);

  @media ${device.desktop} {
    margin-bottom: 70px;
    font-size: 14px;
    line-height: 1.4;
  }
`;

export const ButtonBox = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: block;
  width: calc(100% - 20px);

  @media ${device.mobile} {
    margin: 0 auto;
    text-align: center;
  }
`;

export const ButtonNext = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 40px;
  padding-block: 10px;
  text-align: center;
  border: none;
  background: rgba(var(--bg-button-rgb), 0.35);
  backdrop-filter: blur(2px);
  border-radius: 20px;
  color: var(--button-text-color);
  z-index: 10;
`;

export const ButtonPrev = styled(ButtonNext)`
  left: 20px;
  transform: rotate(180deg);
`;
